import React, { useState, useEffect } from 'react';
import {
  Box,
  Typography,
  Grid,
  Card,
  CardContent,
  CircularProgress,
  Paper,
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow
} from '@mui/material';
import { People as PeopleIcon } from '@mui/icons-material';
import api from '../utils/api';

const DashboardView = ({ eventName }) => {
  const [accessPointCounts, setAccessPointCounts] = useState([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState('');
  const [totalEntries, setTotalEntries] = useState(0);

  useEffect(() => {
    if (eventName) {
      fetchAccessPointCounts();
    }
  }, [eventName]);

  const fetchAccessPointCounts = async () => {
    if (!eventName) return;
    
    try {
      const response = await api.get(`/api/access-point-entry-count/?event=${eventName}`);
      setAccessPointCounts(response.data);
      const total = response.data.reduce((sum, point) => sum + point.count, 0);
      setTotalEntries(total);
    } catch (error) {
      setError('Failed to fetch access point counts');
      console.error('Error fetching counts:', error);
    } finally {
      setLoading(false);
    }
  };

  if (!eventName) {
    return (
      <Typography variant="h6" color="error">
        No event selected. Please select an event first.
      </Typography>
    );
  }

  if (loading) {
    return (
      <Box display="flex" justifyContent="center" alignItems="center" minHeight="400px">
        <CircularProgress />
      </Box>
    );
  }

  if (error) {
    return (
      <Typography color="error" align="center">
        {error}
      </Typography>
    );
  }

  return (
    <Box>
      <Typography variant="h4" gutterBottom>
        Dashboard - {eventName}
      </Typography>
      
      <Grid container spacing={3} sx={{ mb: 4 }}>
        <Grid item xs={12} sm={6} md={4}>
          <Card>
            <CardContent>
              <Typography variant="h6" gutterBottom>
                Total Entries
              </Typography>
              <Typography variant="h3">
                {totalEntries}
              </Typography>
            </CardContent>
          </Card>
        </Grid>
      </Grid>
      
      <Typography variant="h5" gutterBottom>
        Access Point Statistics
      </Typography>
      
      <Grid container spacing={3}>
        {accessPointCounts.map((point) => (
          <Grid item xs={12} sm={6} md={4} key={point.access_point__id}>
            <Card>
              <CardContent>
                <Typography variant="h6" gutterBottom>
                  {point.access_point__name}
                </Typography>
                <Typography variant="h4" color="primary">
                  {point.count}
                </Typography>
                <Typography variant="body2" color="text.secondary">
                  Total Entries
                </Typography>
              </CardContent>
            </Card>
          </Grid>
        ))}
      </Grid>
    </Box>
  );
};

export default DashboardView;
